import { ConfigStateService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cai-identity-settings',
  templateUrl: './identity-settings.component.html',
  standalone: false,
})
export class CustomIdentitySettingsComponent implements OnInit {
  constructor(private config: ConfigStateService) {}

  externalLoginKey = 'Identity.EnableOAuthLogin';
  ldapLoginKey = 'Account.EnableLdapLogin';
  features = [];

  isLdapLoginEnabled = this.config.getFeature(this.ldapLoginKey) === 'true';
  isExternalLoginEnabled = this.config.getFeature(this.externalLoginKey) === 'true';

  ngOnInit(): void {
    if (this.isLdapLoginEnabled) {
      this.features.push(this.ldapLoginKey);
    }

    if (this.isExternalLoginEnabled) {
      this.features.push(this.externalLoginKey);
    }
  }
}
